'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/syntax.js
// module id = 504
// module chunks = 5